import { useContext } from 'react'

import type { UserRole } from '@/types/api'

import { DevRolePreviewContext } from '@/lib/auth/devRolePreviewContext'
import { useAuth } from '@/lib/auth/useAuth'

function useDevRolePreview() {
  const ctx = useContext(DevRolePreviewContext)
  if (!import.meta.env.DEV) return null
  return ctx
}

/** Papel efetivo para RBAC na UI: preview DEV substitui JWT real. */
export function useEffectiveRole(): UserRole | undefined {
  const { user } = useAuth()
  const dev = useDevRolePreview()
  if (import.meta.env.DEV && dev?.previewRole) {
    return dev.previewRole
  }
  return user?.role
}

export function useDevRolePreviewControls() {
  return useDevRolePreview()
}
